import firebase from "firebase"
import Athlete from "./utils/athlete"
import AthleteEventSignUp from "./utils/athletesignup"
import AgeGroup from "./utils/agegroup"

class FirestoreModel {
    constructor() {
        // Initialize Firebase
        this.initialize();
        this.db = firebase.firestore();
        this.firebase = firebase;
    }

    initialize() {
        var firebaseConfig =
        {
            apiKey: "AIzaSyCE49fVbko_MYn7wD278SdY1vpuQxs3Zhk",
            authDomain: "trackmanager.firebaseapp.com",
            databaseURL: "https://trackmanager.firebaseio.com",
            projectId: "trackmanager",
            storageBucket: "trackmanager.appspot.com",
            messagingSenderId: "87468373651",
            appId: "1:87468373651:web:59365b578856888764bf66"
        };
        if (!firebase.apps.length) {
            firebase.initializeApp(firebaseConfig);
        }

    }

    // Team updates
    async putAthlete(athlete, teamId) {
        let publicAthlete = new Athlete();

        console.log("Attempting")
        console.log(athlete)
        console.log(athlete.rawObject(teamId))


        if (athlete.AthleteId == null || athlete.AthleteId === "") {
            // This is a new athlete

            var document = await this.db.collection("teams").doc(teamId).collection("athletes").add(athlete.rawObject(teamId));
            athlete.AthleteId = document.id;
            athlete.id = document.id;

            publicAthlete.CopyFromObject(athlete);
            publicAthlete.ParentCell = "";
            publicAthlete.ParentName = "";

            console.log("Adding")
            console.log(athlete)
            console.log(athlete.rawObject(teamId))

            await this.db.collection("publicTeams").doc(teamId).collection("athletes").doc(document.id).set(publicAthlete.rawObject(teamId));
            await this.db.collection("teams").doc(teamId).collection("athletes").doc(document.id).set(athlete.rawObject(teamId));
        }
        else {
            await this.db.collection("teams").doc(teamId).collection("athletes").doc(athlete.id).update(athlete.rawObject(teamId));

            publicAthlete.CopyFromObject(athlete);
            publicAthlete.ParentCell = "";
            publicAthlete.ParentName = "";

            console.log("Updateing")
            console.log(athlete)
            console.log(athlete.rawObject(teamId))

            await this.db.collection("publicTeams").doc(teamId).collection("athletes").doc(athlete.id).update(publicAthlete.rawObject(teamId));
        }

        return athlete;
    }

    async putUser(userId, profileName, primaryTeamName, primaryTeamId, currentMeet) {
        if (userId !== null) {
            const userRef = this.db.collection('users').doc(userId);

            const res = await userRef.set({
                TeamId: primaryTeamId
            }, { merge: true });

        }
        return true;
    }

    async putCompleteUser(user) {
        console.log("Updating user: " + user.Id, user);

        await this.db.collection('users').doc(user.Id).update(user);
        return true;
    }

    async putCompleteTeam(team) {
        await this.db.collection('teams').doc(team.Id).update(team);
        return true;
    }

    async addUser(user) {
        let id = 0;
        await this.db.collection('users').add(user).then((docRef) => id = docRef.id);

        user.Id = id;

        await this.db.collection('users').doc(id).set(user);

        return true;
    }

    async updateUserTeam(userId, team) {
        const userRef = await this.db.collection('users').doc(userId).get();

        let userDetails = userRef.data();

        let teamFound = userDetails.ProfileTeams.find(e => { return e.Id === team.Id; });

        const obj = {
            ClubId: team.ClubId,
            ClubName: team.ClubName,
            Id: team.Id,
            Name: team.Name,
            NumberOfAthletes: 0,
            Role: "Coach"
        };

        if (teamFound === undefined) {
            if (userDetails.ProfileTeams === undefined)
                userDetails.ProfileTeams = [];
            userDetails.ProfileTeams.push(obj);


        }
        else {
            // Not sure this is possible, but update the name
            obj.Name = team.Name;

            userDetails.ProfileTeams = userDetails.ProfileTeams.filter(e => e.Id !== obj.Id);
            userDetails.ProfileTeams.push(obj);
        }

        this.putCompleteUser(userDetails);

        await this.db.collection('users').doc(userId).update(userDetails);

        return true;
    }

    async getUserByEmail(email) {
        if (email !== null) {
            const userDocRef = await this.db.collection("users").where("Email", "==", email).get();
            // User Id is the userAuth Id, we get this on auth

            if (userDocRef.docs.length > 0) {
                return userDocRef.docs[0].data();
            }
            return null;
        }
    }

    async addMeet(meet) {
        let id = 0;
        meet.CreatedDtTm = this.getCurrentDateString();
        await this.db.collection('meets').add(meet).then((docRef) => id = docRef.id);
        meet.MeetId = id;
        await this.db.collection('meets').doc(id).set(meet);
        return true;
    }

    async putMeet(meet) {
        meet.UpdatedDtTm = this.getCurrentDateString();
        await this.db.collection("meets").doc(meet.MeetId).update(meet);
        return true;
    }

    async getUserInvites(userid, email) {
        // If this is a new user there maybe invites shown by email address as the ID ws unknown


        const teamsWithOpenInvites = []

        // For now only get by email
        // if this needs extending to ID check that the status is pending in the staff collection
        for (var i = 0; i < 1; i++) {
            let field = new firebase.firestore.FieldPath('Roles', i === 0 ? email : userid)
            let userDocRef = await this.db.collection("teams").where(field, "==", 'Coach').get();

            if (userDocRef.docs.length > 0) {
                userDocRef.forEach((doc) => {
                    const obj = doc.data();
                    teamsWithOpenInvites.push(obj)
                }
                )

            }
        }

        return teamsWithOpenInvites;
    }


    async acceptUserInvites(team, user, accepted) {
        // If this is a new user there maybe invites shown by email address as the ID ws unknown
        let userDocRef = await this.db.collection("teams").where("Id", "==", team.Id).get();

        let runUpdate = false;
        let teamFromDB = {};

        if (userDocRef.docs.length > 0) {
            userDocRef.forEach((doc) => {
                teamFromDB = doc.data();

                // if this is an accept or reject the role named for email address should be removed
                delete teamFromDB.Roles[user.Email];

                if (accepted)
                    teamFromDB.Roles[user.UserId] = "Coach";

                teamFromDB.Staff = teamFromDB.Staff.map((e) => {
                    if (e.EMail === user.Email && e.Status === "Pending") {
                        e.ProfileName = user.ProfileName
                        e.Id = user.UserId;
                        if (accepted)
                            e.Status = "Accepted";
                        else
                            e.Status = "Declined";
                        return e;
                    }
                    return e;
                })

                runUpdate = true;

            }
            )

            if (runUpdate) {
                await this.putCompleteTeam(teamFromDB);
            }


        }

        return teamFromDB;
    }
    //

    async getUser(userAuthId) {
        if (userAuthId !== null) {
            // User Id is the userAuth Id, we get this on auth
            var userDocRef = await this.db.collection("users").where("UserId", "==", userAuthId).get();

            if (userDocRef.docs.length > 0) {
                return userDocRef.docs[0].data();
            }
            return true;
        }
    }


    async delAthlete(athlete, teamId) {
        if (athlete.id !== null && athlete.id !== "") {
            await this.db.collection("teams").doc(teamId).collection("athletes").doc(athlete.id).delete();
            await this.db.collection("publicTeams").doc(teamId).collection("athletes").doc(athlete.id).delete();
        }

        return athlete;
    }

    async putOutList(teamId, meetId, outList) {
        const newOutList = { OutList: outList };

        await this.checkParentExistsMeetTeam(meetId, teamId);

        await this.db.collection("meets").doc(meetId).collection("teams").doc(teamId).update(newOutList);
    }

    async removeFromOutList(teamId, meetId, athleteId) {
        // There is a chance that this is the first usage, and the element doesnt exist.
        await this.checkParentExistsMeetTeam(meetId, teamId);

        await this.db.collection("meets").doc(meetId).collection("teams").doc(teamId).arrayRemove(athleteId);
    }

    async checkParentExistsMeetTeam(meetId, teamId) {
        var docRef = await this.db.collection("meets").doc(meetId).collection("teams").doc(teamId).get();

        if (!docRef.exists) {
            await this.db.collection("meets").doc(meetId).collection("teams").doc(teamId).set({ Updated: this.getCurrentDateString() })
        }
        return true;
    }

    async putTeam(team) {
        team.UpdatedDtTm = this.getCurrentDateString();
        await this.db.collection("teams").doc(team.Id).update(team);
    }

    async addTeam(team, user) {
        if (team.Id === undefined) {

            team.Roles = {}

            team.Roles[user.UserId] = 'Coach';

            team.Staff = [];
            team.Staff.push({
                EMail: user.Email,
                Id: user.UserId,
                Status: 'Accepted',
                ProfileName: user.ProfileName
            })

            var document = await this.db.collection("teams").add(team);
            team.Id = document.id;

            console.log({ team });

            // store the id back into the new
            team.UpdatedDtTm = team.AddedDtTm = this.getCurrentDateString();

            await this.putTeam(team);

            await this.addTeamToUserProfile(user, team);

        }

    }

    async addTeamToUserProfile(currentUser, team) {

        const obj = {
            ClubId: team.ClubId,
            ClubName: team.ClubName,
            Id: team.Id,
            Name: team.Name,
            NumberOfAthletes: 0,
            Role: "Coach"
        };

        const fireModel = new FirestoreModel();

        if (currentUser.ProfileTeams === undefined)
            currentUser.ProfileTeams = [];
        currentUser.ProfileTeams.push(obj);

        fireModel.putCompleteUser(currentUser);
    }



    /*
    private async Task<int> AthleteCountPutAsync(string teamId)
    {
        List<AthleteMeetStatus> athletes = await AthletesRecordsByTeamAsync(teamId);

        var data = new
        {
            NumberOfAthletes = athletes.Count
        };
        await CrossCloudFirestore.Current.Instance.GetCollection("teams").GetDocument(teamId).UpdateDataAsync(data);

        return athletes.Count;
    }

    public async Task<Athlete> AthleteDelAsync(Athlete athlete, string teamId)
    {
        if (athlete.AthleteId != null && athlete.AthleteId != "")
        {
            // This is a new athlete
            await CrossCloudFirestore.Current.Instance.GetCollection("teams").GetDocument(teamId).GetCollection("athletes").GetDocument(athlete.AthleteId).DeleteDocumentAsync();
            try
            {
                await CrossCloudFirestore.Current.Instance.GetCollection("publicTeams").GetDocument(teamId).GetCollection("athletes").GetDocument(athlete.AthleteId).DeleteDocumentAsync();
            }
            catch (Exception) 
            { };
            
            await AthleteCountPutAsync(teamId);
        }
        return athlete;
    }
*/



    async fetchPrivateTeamList(teamId) {
        var athleteList = [];
        var querySnapshot = await this.db.collection("teams").doc(teamId).collection("athletes").get();

        querySnapshot.forEach((doc) => {
            const obj = doc.data();
            obj.id = doc.id;
            if (obj.AthleteId === null || obj.AthleteId === undefined || obj.AthleteId === "")
                obj.AthleteId = doc.id;
            athleteList.push(obj);
        });

        // TODO - dont allow name to be saved as null in app
        athleteList.forEach((ath) => {
            if (ath.Name === null || ath.Name === undefined)
                ath.Name = "Name not set";
        });

        return athleteList.sort((a, b) => {
            let fa = a.AlsoKnownAs === null || a.AlsoKnownAs === '' ? a.Name.toLowerCase() : a.AlsoKnownAs.toLowerCase(),
                fb = b.AlsoKnownAs === null || b.AlsoKnownAs === '' ? b.Name.toLowerCase() : b.AlsoKnownAs.toLowerCase();

            if (fa < fb) {
                return -1;
            }
            if (fa > fb) {
                return 1;
            }
            return 0;

        })
    };



    async fetchMeetTeamTagsAsync(teamId, meetId) {
        var docRef = await this.db.collection("meets").doc(meetId).collection("teams").doc(teamId).get();

        if (docRef.exists) {
            // Todo - read complete athlete list
            //athleteList = doc.data()[""]

            return docRef.data();
        }
        return {};
    };

    async fetchAllEventsAsync() {
        //const db = firebase.firestore();
        var docRef3 = this.db.collection("reference").where("ContentType", "==", "Event");
        const querySnapshot = await docRef3.get();
        let events = [];

        querySnapshot.forEach((doc) => {
            events = doc.data().Events;
        });

        events.sort((a, b) => (a.SortOrder > b.SortOrder) ? 1 : -1)

        return events;
    }

    async fetchAllQualifiers() {
        var docRef3 = this.db.collection("reference").where("ContentType", "==", "Division");
        const querySnapshot = await docRef3.get();
        let divQualifiers = [];

        querySnapshot.forEach((doc) => {
            divQualifiers = doc.data().Divisions;
        });

        return divQualifiers;
    }


    async fetchPublicTeamList(teamId) {
        var athleteList = [];
        var querySnapshot = await this.db.collection("publicTeams").doc(teamId).collection("athletes").get();

        querySnapshot.forEach((doc) => {
            athleteList.push(doc.data());
        });

        // TODO - dont allow name to be saved as null in app
        athleteList.forEach((ath) => {
            if (ath.Name === null || ath.Name === undefined)
                ath.Name = "Name not set";
        });

        return athleteList.sort((a, b) => {
            let fa = a.AlsoKnownAs === null || a.AlsoKnownAs === '' ? a.Name.toLowerCase() : a.AlsoKnownAs.toLowerCase(),
                fb = b.AlsoKnownAs === null || b.AlsoKnownAs === '' ? b.Name.toLowerCase() : b.AlsoKnownAs.toLowerCase();

            if (fa < fb) {
                return -1;
            }
            if (fa > fb) {
                return 1;
            }
            return 0;

        })
    };

    async fetchTeamAsync(teamId) {
        var docRef = await this.db.collection("teams").doc(teamId).get();

        if (docRef.exists) {
            return docRef.data();
        }
        return;
    };

    async putAthleteCount(teamId) {
        let team = await this.fetchPrivateTeamList(teamId);

        const count = { NumberOfAthletes: team.length };

        await this.db.collection("teams").doc(teamId).update(count);

        return count;
    }

    async fetchMeetAsync(meetId) {
        var docRef = await this.db.collection("meets").doc(meetId).get();

        if (docRef.exists) {
            return docRef.data();
        }
        return;
    };



    async fetchUserMeetsAsync(userId) {
        // we have a user id, get the user and then the list of clubs
        var userDocRef = await this.db.collection("users").where("UserId", "==", userId).get();
        var meetsRef = await this.db.collection("meets").get();

        let meetList = [];

        if (userDocRef.docs.length > 0) {
            for (let i = 0; i < userDocRef.docs[0].data().ProfileTeams.length; i++) {
                const profileTeam = userDocRef.docs[0].data().ProfileTeams[i];

                for (let c = 0; c < meetsRef.docs.length; c++) {
                    const meet = meetsRef.docs[c].data();

                    for (let n = 0; n < meet.Clubs.length; n++) {
                        const club = meet.Clubs[n];
                        if (profileTeam.ClubId === club.Id) {
                            if (meetList.findIndex((meetCheck) => { return meetCheck.MeetId === meet.MeetId }) === -1)
                                meetList.push(meet);
                            break;
                        }

                    }
                }
            }
        }

        return meetList.sort((a, b) => {
            if (a.Date < b.Date) {
                return -1;
            }
            if (a.Date > b.Date) {
                return 1;
            }
            return 0;

        })
    };

    async fetchClubsAsync(clubId) {

        var clubsRef = await this.db.collection("clubs").get();

        let clubs = [];

        for (let c = 0; c < clubsRef.docs.length; c++) {
            const club = clubsRef.docs[c].data();

            if (clubId && club.Id === clubId)
                clubs.push(club);
            else if (!clubId)
                clubs.push(club);

        }
        return clubs;
    }


    async fetchClubMeetsAsync(clubId) {
        // ALL TEAMS within a club have gthe same meets, this is probably 95% true
        // However some users can belong to multiple clubs, this search should return only
        // those meets for the club selected

        var clubsRef = await this.db.collection("meets").get();

        let meetList = [];

        for (let c = 0; c < clubsRef.docs.length; c++) {
            const meet = clubsRef.docs[c].data();

            for (let n = 0; n < meet.Clubs.length; n++) {
                const club = meet.Clubs[n];
                if (clubId === club.Id) {
                    if (meetList.findIndex((meetCheck) => { return meetCheck.MeetId === meet.MeetId }) === -1)
                        meetList.push(meet);
                    break;
                }

            }
        }

        return meetList.sort((a, b) => {
            if (a.Date < b.Date) {
                return -1;
            }
            if (a.Date > b.Date) {
                return 1;
            }
            return 0;

        })
    };


    async fetchUserTeamsAsync(userId) {
        var docRef = await this.db.collection("users").where("UserId", "==", userId).get();
        if (docRef.docs.length > 0) {
            return docRef.docs[0].data();
        }

        return;
    };

    async fetchAllAgeGroups() {
        var colRef = await this.db.collection("division").get();

        var ageGroups = [];

        if (colRef.docs.length > 0) {
            colRef.docs.forEach((division) => {
                // Important to make sure each item has the division identifier set
                // otherwise no way to tell which is int and which is youth

                let foundAgeGroup = new AgeGroup();
                //let divn = division.data();
                foundAgeGroup.SetFromObj(division.data());
                //foundAgeGroup.id = divn.AgeGroupId;
                //foundAgeGroup.AgeRange = divn.AgeRange;
                //foundAgeGroup.AthleticNetDivisionCode = divn.AthleticNetDivisionCode;
                //foundAgeGroup.Description = divn.Description;
                //foundAgeGroup.DivisionFilter = divn.DivisionFilter;
                //foundAgeGroup.GenderDescription = divn.GenderDescription;
                //foundAgeGroup.Gender.SetFromCode(divn.Gender);

                ageGroups.push(foundAgeGroup);
            })
        }


        return ageGroups.sort(function (a, b) { return a.AgeOrder() != b.AgeOrder() ? a.AgeOrder() - b.AgeOrder() : a.Gender.id - b.Gender.id });

    }


    async fetchDefaultTeamEvents(team) {
        // The team includes a list of divisions, search for each
        // Division list has divisionId at top level, therefore copy to children as they are going into one list
        var events = [];

        for (var i = 0; i < team.Divisions.length; i++) {
            const thisDivision = team.Divisions[i].AgeGroupId;
            var docRef = await this.db.collection("division").doc(thisDivision).get();

            if (docRef.exists) {
                let obj = docRef.data()

                obj.Events.forEach((division) => {
                    // Important to make sure each item has the division identifier set
                    // otherwise no way to tell which is int and which is youth
                    division.DivisionId = thisDivision;
                    events.push(division);
                })
            }
        }

        events.sort((a, b) => (a.SortOrder > b.SortOrder) ? 1 : -1)

        return events;
    }

    async putMeetTeamSignupsAsync(teamId, meetId, eventId, athlete, participatingAthleteDetails) {
        await this.putMeetTeamEventSignupsAsync(teamId, meetId, eventId, athlete, participatingAthleteDetails);
        await this.putMeetTeamAthleteSignupsAsync(teamId, meetId, eventId, athlete, participatingAthleteDetails);
    }

    async putMeetTeamAthleteSignupsAsync(teamId, meetId, eventId, athlete, participatingAthleteDetails) {
        let document = await this.db.collection("meets").doc(meetId).collection("teams").doc(teamId).collection("athletes").doc(athlete.AthleteId).get();

        let currentArray = document.data();
        let athleteSignUp = new AthleteEventSignUp();
        let dataSetFound = true;

        console.log({ AthletePublicCurrentArray: currentArray });

        if (document.exists) {
            // Todo - read complete athlete list
            //athleteList = doc.data()[""]
            let found = false
            if (currentArray.events != null) {
                currentArray.events.forEach((e) => {
                    if (e.EventId == eventId) {
                        e.SignedUp = participatingAthleteDetails.in;
                        e.Notes = participatingAthleteDetails.Notes || "";
                        found = true;
                    }
                }
                )
            }
            else {
                currentArray.events = []
            }

            if (found === false) {
                athleteSignUp.fromObject(athlete);
                athleteSignUp.SignedUp = participatingAthleteDetails.in;
                athleteSignUp.EventId = "" + eventId;
                athleteSignUp.Notes = participatingAthleteDetails.Notes || "";
                currentArray.events.push(athleteSignUp.toObject());
            }
        }
        else {
            if (currentArray === undefined) {
                currentArray = {};
                dataSetFound = false;
            }
            currentArray.events = [];
            athleteSignUp.fromObject(athlete);
            athleteSignUp.SignedUp = participatingAthleteDetails.in;;
            athleteSignUp.Notes = participatingAthleteDetails.Notes || "";
            athleteSignUp.EventId = eventId;

            currentArray.events.push(athleteSignUp.toObject());
        }

        const newObj = { events: currentArray.events };

        await this.db.collection("meets").doc(meetId).collection("teams").doc(teamId).collection("athletes").doc(athlete.AthleteId).set(newObj);
    }

    async putMeetTeamEventSignupsAsync(teamId, meetId, eventId, athlete, participatingAthleteDetails) {
        let document = await this.db.collection("meets").doc(meetId).collection("teams").doc(teamId).collection("events").doc("" + eventId).get();


        let currentArray = document.data();
        let athleteEventSignUp = new AthleteEventSignUp();
        let dataSetFound = true;

        console.log({ EventPublicCurrentArray: currentArray });

        if (document.exists) {
            // Todo - read complete athlete list
            //athleteList = doc.data()[""]
            let found = false
            currentArray.athletes.forEach((e) => {
                if (e.AthleteId === athlete.AthleteId) {
                    e.SignedUp = participatingAthleteDetails.in;
                    e.Notes = participatingAthleteDetails.Notes || "";
                    found = true;
                }
            }
            )
            if (found === false) {
                athleteEventSignUp.fromObject(athlete);
                athleteEventSignUp.SignedUp = participatingAthleteDetails.in;
                athleteEventSignUp.Notes = participatingAthleteDetails.Notes || "";
                athleteEventSignUp.EventId = "" + eventId;
                currentArray.athletes.push(athleteEventSignUp.toObject());
            }
        }
        else {
            if (currentArray === undefined) {
                currentArray = {};
                dataSetFound = false;
            }
            currentArray.athletes = [];
            athleteEventSignUp.fromObject(athlete);
            athleteEventSignUp.SignedUp = participatingAthleteDetails.in;;
            athleteEventSignUp.Notes = participatingAthleteDetails.Notes || "";

            athleteEventSignUp.EventId = eventId;
            currentArray.athletes.push(athleteEventSignUp.toObject());
        }

        const newObj = { athletes: currentArray.athletes };

        await this.db.collection("meets").doc(meetId).collection("teams").doc(teamId).collection("events").doc("" + eventId).set(newObj);

    }

    async fetchMeetTeamEventSignupsAsync(teamId, meetId) {
        var athleteList = [];
        var athleteSignUps = [];
        const readSeparateAthleteList = false;
        var querySnapshot = await this.db.collection("meets").doc(meetId).collection("teams").doc(teamId).collection("events").get();

        querySnapshot.forEach((doc) => {
            for (var n = 0; n < doc.data().athletes.length; n++) {
                var athleteEventSignUp = new AthleteEventSignUp();
                athleteEventSignUp.EventId = doc.id;

                athleteEventSignUp.fromObject(doc.data().athletes[n]);
                //athleteEventSignUp.Name = doc.data().athletes[n].Name;
                //athleteEventSignUp.AthleteId = doc.data().athletes[n].AthleteId;
                //athleteEventSignUp.Record = doc.data().athletes[n].Result;
                //athleteEventSignUp.Notes = doc.data().athletes[n].Notes;
                athleteSignUps.push(athleteEventSignUp);
                if (readSeparateAthleteList === false) {
                    let athlete = new Athlete();
                    athlete.name = athleteEventSignUp.Name;
                    athlete.athleteId = athleteEventSignUp.AthleteId;
                    // Need to create an athlete list as we go as there is no separate list
                    var x = athleteList.find(function (ath) {
                        return (ath.AthleteId === athlete.AthleteId && ath.Name === athlete.Name);
                    });
                    if (x == null)
                        athleteList.push(athlete);
                }
            }
        })

        athleteList = athleteList.sort((a, b) => {
            let fa = a.Name.toLowerCase(),
                fb = b.Name.toLowerCase();

            if (fa < fb) {
                return -1;
            }
            if (fa > fb) {
                return 1;
            }
            return 0;

        })
        return { athleteList, athleteSignUps };
    };

    getCurrentDateString() {
        let current = new Date();
        let cDate = current.getFullYear() + '-' + (current.getMonth() + 1) + '-' + current.getDate();
        let cTime = current.getHours() + ":" + current.getMinutes() + ":" + current.getSeconds();
        let dateTime = cDate + ' ' + cTime;
        return dateTime;
    }

    getDateFromDateStr(inputDate) {
        let parts = inputDate.split('-');

        if (parts.length === 3) {
            let newDate = new Date()
            newDate.setFullYear(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2]));
            return newDate;
        }
    }
}

export default FirestoreModel;

